import React from "react";
import { useSelector } from "react-redux";
import WindowDimensionsProvider from "../../components/WindowDimensionsProvider";
import { State } from "../../store/types";
import styled from "../../styled";
import { useGetAccountQuery } from "../../graphql/hooks/useGetAccountQuery";
import { LoadingIndicator } from "../../design-system/components/LoadingIndicator";
import { Redirect, useLocation } from "react-router";
import { SignUpPaths } from ".";
import { getRedirectTo } from "./utils/redirect";
import { StandaloneLayout } from "../../components/StandaloneLayout";

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export interface ContainerChildrenProps {
  isAuthenticated: boolean;
}

type ChildType = (
  props: ContainerChildrenProps
) => React.ReactElement<ContainerChildrenProps>;

const SignUpContainer: React.FC<{
  children: ChildType;
}> = props => {
  const PageComponent = props.children;

  const isAuthenticated = useSelector((state: State) => {
    return state.auth.authenticated;
  });

  const location = useLocation();

  // Only redirect if the patient is re-entering the sign up flow
  const shouldRedirect =
    location.pathname === SignUpPaths.SIGNUP_CREATE_ACCOUNT;

  const { data, loading } = useGetAccountQuery({
    skip: !isAuthenticated || !shouldRedirect
  });

  if (loading) {
    return (
      <LoadingWrapper>
        <LoadingIndicator />
      </LoadingWrapper>
    );
  }

  // TODO Add something went wrong modal?

  if (data && data.account) {
    const patient =
      data.account && data.account.patients.edges.length > 0
        ? data.account.patients.edges[0].node
        : null;

    const secondaryPatient =
      data.account && data.account.patients.edges.length > 1;

    const redirectTo = getRedirectTo({
      account: data.account,
      patient: patient,
      accountComplete: secondaryPatient
    });

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    }
  }

  return (
    <WindowDimensionsProvider>
      <StandaloneLayout contentWidth="560">
        <PageComponent isAuthenticated={isAuthenticated} />
      </StandaloneLayout>
    </WindowDimensionsProvider>
  );
};

export default SignUpContainer;
